import React from 'react'
import ComputerConfirmedSlot from './ComputerConfirmedSlot'

export default function ComputerSlotPage ({ box, slot, onCancel, slotStatus }) {
  return (
    <ComputerConfirmedSlot box={box} slot={slot} onCancel={onCancel} slotStatus={slotStatus} />
  )
}
